import React, { useEffect } from "react";
import "./Galeria.scss";
const Galeria = (props) => {
  const handleShowModalGaleria = (tipo, url) => {
    props.setTypeGaleria(tipo);
    props.setUrlGaleria(url);
    props.setOpenGaleria(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="contenedor_galeria">
      <div className="grid">
        {/* <div className='img-grid' onClick={()=>handleShowModalGaleria('video','/assets/galeria/gallery/videos/1.mp4')}>
                    <video muted loop autoPlay src="/assets/galeria/gallery/videos/1.mp4"></video>
                    <div className='caption'>
                    </div>
                </div>
                <div className='img-grid' onClick={()=>handleShowModalGaleria('video','/assets/galeria/gallery/videos/2.mp4')}>
                    <video muted loop autoPlay src="/assets/galeria/gallery/videos/2.mp4"></video>
                    <div className='caption'>
                    </div>
                </div> */}

                <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/Acceso1.jpg")
          }
        >
          <img src="/assets/galeria/gallery/Acceso1.jpg" alt="" />
          <div className="caption">
            <p>Acceso principal</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/Acceso2.jpg")
          }
        >
          <img src="/assets/galeria/gallery/Acceso2.jpg" alt="" />
          <div className="caption">
            <p>Acceso principal</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/Accesso3.jpg")
          }
        >
          <img src="/assets/galeria/gallery/Accesso3.jpg" alt="" />
          <div className="caption">
            <p>Acceso principal</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/Acceso4.jpg")
          }
        >
          <img src="/assets/galeria/gallery/Acceso4.jpg" alt="" />
          <div className="caption">
            <p>Acceso principal</p>
          </div>
        </div>


        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/CasaClub1.jpg")
          }
        >
          <img src="/assets/galeria/gallery/CasaClub1.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/CasaClub2.jpg")
          }
        >
          <img src="/assets/galeria/gallery/CasaClub2.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/CasaClub3.jpg")
          }
        >
          <img src="/assets/galeria/gallery/CasaClub3.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/CasaClub4.jpg")
          }
        >
          <img src="/assets/galeria/gallery/CasaClub4.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/CasaClub5.jpg")
          }
        >
          <img src="/assets/galeria/gallery/CasaClub5.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
       
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-07.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-07.jpg" alt="" />
          <div className="caption">
            <p>Alberca</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-08.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-08.jpg" alt="" />
          <div className="caption">
            <p>Alberca</p>
          </div>
        </div>
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-10.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-10.jpg" alt="" />
          <div className="caption">
            <p>Alberca</p>
          </div>
        </div>
        
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-14.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-14.jpg" alt="" />
          <div className="caption">
            <p>Alberca</p>
          </div>
        </div>
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-22.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-22.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-26.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-26.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-31.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-31.jpg" alt="" />
          <div className="caption">
            <p>Entrada</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria("img", "/assets/galeria/gallery/VelaSur-33.jpg")
          }
        >
          <img src="/assets/galeria/gallery/VelaSur-33.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_1.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_1.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_2.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_2.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_4.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_4.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_5.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_5.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_6.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_6.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_7.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_7.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_10.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_10.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_11.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_11.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
        <div
          className="img-grid"
          onClick={() =>
            handleShowModalGaleria(
              "img",
              "/assets/galeria/gallery/img_velasur_12.jpg"
            )
          }
        >
          <img src="/assets/galeria/gallery/img_velasur_12.jpg" alt="" />
          <div className="caption">
            <p>Casa Club</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Galeria;
